import DismissButton from './DismissButton';
import ConnectedDismissButton from './ConnectedDismissButton';

export { DismissButton };
export default ConnectedDismissButton;
